import { useCallback, useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

async function fetchRequirementDefectRatio(queryString) {
  const url = `${QUALITY_SERVICE_API_URL}/requirement-defect-ratio/summary${queryString ? `?${queryString}` : ''}`;
  console.log('[useRequirementDefectRatio] Fetching from:', url);
  try {
    const response = await api.get(url);
    console.log('[useRequirementDefectRatio] Success:', response.data);
    return response.data;
  } catch (err) {
    console.error('[useRequirementDefectRatio] Error:', {
      status: err.response?.status,
      statusText: err.response?.statusText,
      data: err.response?.data,
      message: err.message,
    });
    throw err;
  }
}

function useRequirementDefectRatio(filters, dateRange) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Default to last 30 days if no dateRange provided
  const now = new Date();
  const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
  const effectiveDateRange = dateRange || { startDate: thirtyDaysAgo, endDate: now };
  
  const params = new URLSearchParams();
  ['domain', 'group', 'unit'].forEach(key => {
    (filters?.[key] || []).forEach(value => params.append(key, value));
  });
  const formatDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  if (effectiveDateRange?.startDate) params.set('from', formatDate(effectiveDateRange.startDate));
  if (effectiveDateRange?.endDate) params.set('to', formatDate(effectiveDateRange.endDate));
  const queryString = params.toString();

  const fetchRatio = useCallback(async (isCancelled = () => false) => {
    setLoading(true);
    setError(null);
    setData(null);
    try {
      const ratio = await fetchRequirementDefectRatio(queryString);
      if (!isCancelled()) setData(ratio);
    } catch (err) {
      if (!isCancelled()) setError(err);
    } finally {
      if (!isCancelled()) setLoading(false);
    }
  }, [queryString]);

  useEffect(() => {
    let cancelled = false;
    fetchRatio(() => cancelled);
    return () => { cancelled = true; };
  }, [fetchRatio]);

  return { data, loading, error, refetch: () => fetchRatio() };
}

export default useRequirementDefectRatio;
